import { render, staticRenderFns } from "./TedsLauncherUiSettings.vue?vue&type=template&id=375c2e69&"
import script from "./TedsLauncherUiSettings.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherUiSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherUiSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports